/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliStudentDtoApiResponse } from '../../models/amoxcalli-student-dto-api-response';
import { AmoxcalliUpdateStudentDto } from '../../models/amoxcalli-update-student-dto';

export interface ApiStudentsIdPut$Plain$Params {
  id: string;
      body?: AmoxcalliUpdateStudentDto
}

export function apiStudentsIdPut$Plain(http: HttpClient, rootUrl: string, params: ApiStudentsIdPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliStudentDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, apiStudentsIdPut$Plain.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliStudentDtoApiResponse>;
    })
  );
}

apiStudentsIdPut$Plain.PATH = '/api/students/{id}';
